export type TvChartId =
  | "bookings_chart"
  | "streams_chart"
  | "contacts_chart"
  | "venues_chart";

export type TvTemplate = {
  id: string;
  name: string;
  description?: string;
  chartIds: TvChartId[];
  overviewDurationMs: number;
  detailDurationMs: number;
};

export type TvDashboardTemplateState = {
  templates: TvTemplate[];
  liveTemplateId: string | null;
};

export const TV_DASHBOARD_TEMPLATES_KEY = "tvDashboardTemplates";

export const AVAILABLE_TV_CHARTS: {
  id: TvChartId;
  title: string;
  description: string;
}[] = [
  {
    id: "bookings_chart",
    title: "Bookings Chart",
    description: "Shows booking totals and booking trends",
  },
  {
    id: "streams_chart",
    title: "Streams Chart",
    description: "Shows stream totals, trends, and stream type split",
  },
  {
    id: "contacts_chart",
    title: "Contacts Chart",
    description: "Shows contacts grouped by type",
  },
  {
    id: "venues_chart",
    title: "Venues Chart",
    description: "Shows venues grouped by venue type",
  },
];

export const DEFAULT_TV_TEMPLATE_STATE: TvDashboardTemplateState = {
  templates: [
    {
      id: "default-dashboard",
      name: "Default Dashboard",
      description: "Default TV dashboard",
      chartIds: [
        "bookings_chart",
        "streams_chart",
        "contacts_chart",
        "venues_chart",
      ],
      overviewDurationMs: 12000,
      detailDurationMs: 7000,
    },
  ],
  liveTemplateId: "default-dashboard",
};

export const getTvTemplateState = (): TvDashboardTemplateState => {
  const saved = localStorage.getItem(TV_DASHBOARD_TEMPLATES_KEY);

  if (!saved) {
    localStorage.setItem(
      TV_DASHBOARD_TEMPLATES_KEY,
      JSON.stringify(DEFAULT_TV_TEMPLATE_STATE),
    );

    return DEFAULT_TV_TEMPLATE_STATE;
  }

  try {
    return JSON.parse(saved) as TvDashboardTemplateState;
  } catch {
    localStorage.setItem(
      TV_DASHBOARD_TEMPLATES_KEY,
      JSON.stringify(DEFAULT_TV_TEMPLATE_STATE),
    );

    return DEFAULT_TV_TEMPLATE_STATE;
  }
};

export const saveTvTemplateState = (state: TvDashboardTemplateState) => {
  localStorage.setItem(TV_DASHBOARD_TEMPLATES_KEY, JSON.stringify(state));

  window.dispatchEvent(
    new StorageEvent("storage", {
      key: TV_DASHBOARD_TEMPLATES_KEY,
      newValue: JSON.stringify(state),
    }),
  );
};